<div>
  <div class="toolbar">
    <h1 class="toolbar__title text--xxl text--light text--primary spacing--margin-right">
      {{ 'manualCrops.manualCropsTitle' | translate }}
    </h1>
    <div class="toolbar-actions">
      <button mat-stroked-button (click)="navigateBack()" class="toolbar-button" [disabled]="isNexusLoading$ | async">
        @if (isNexusLoading$ | async) {
          <mat-icon class="spinner">autorenew</mat-icon>
        } @else {
          <mat-icon>arrow_back</mat-icon>
        }
        <span>{{ 'manualCrops.backToDashboard' | translate }}</span>
      </button>

      <button mat-raised-button (click)="addManualCrop()" class="toolbar-button" color="accent">
        <mat-icon>add</mat-icon>
        <span>{{ 'add' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Desktop Table View -->
  <mat-table mat-table [dataSource]="cropFields$" data-test="sprays-table" class="desktop-table">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.name' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">{{ filterItem.name }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="province">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.province' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">{{ filterItem.province }}</mat-cell>
    </ng-container>
    <ng-container style="width: 25%" matColumnDef="crop">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.crop' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem" class="flex--child-auto">{{ filterItem.cropName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="cropVariety">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.cropVariety' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">{{ filterItem.cropVarietyName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="areaInHectares">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.areaInHectares' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">{{ filterItem.areaInHectares }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="soilType">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.soilType' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">{{ filterItem.soilTypeName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="groundwaterPreservation">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.groundwaterPreservation' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">
        <mat-icon>{{ filterItem.groundwaterPreservation ? 'check' : '' }}</mat-icon>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="planetProof">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.planetProof' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">
        <mat-icon>{{ filterItem.planetProof ? 'check' : '' }}</mat-icon>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="organic">
      <mat-header-cell *matHeaderCellDef>{{ 'manualCrops.organic' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let filterItem">
        <mat-icon>{{ filterItem.organic ? 'check' : '' }}</mat-icon>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let filterItem" class="actions-cell">
        <div class="actions-container">
          <div
            [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
            [matTooltipDisabled]="!isCropYearReadOnly()"
          >
            <button
              [disabled]="isCropYearReadOnly()"
              (click)="upsertManualCrop(filterItem)"
              mat-icon-button
              data-test="edit-spray"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <div
            [matTooltip]="
              isCropYearReadOnly()
                ? ('UI.CurrentYearOnlyMutationMessage' | translate)
                : filterItem.isParticipatingToBem
                  ? ('report.deleteCropFieldButtonDisabledTooltip' | translate)
                  : ''
            "
            [matTooltipDisabled]="!isCropYearReadOnly() && !filterItem.isParticipatingToBem"
          >
            <button
              [disabled]="isCropYearReadOnly() || filterItem.isParticipatingToBem"
              (click)="deleteManualCrop(filterItem.id)"
              mat-icon-button
              data-test="delete-spray"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" data-test="sprays-row"></mat-row>
  </mat-table>

  <!-- Mobile Card View -->
  <div class="mobile-cards">
    @if (cropFields$ | async; as cropFields) {
      @for (item of cropFields; track item.id) {
        <mat-card class="crop-card">
          <mat-card-content>
            <div class="card-header">
              <h3 class="crop-name">{{ item.name }}</h3>
              <div class="actions-container">
                <div
                  [matTooltip]="'UI.CurrentYearOnlyMutationMessage' | translate"
                  [matTooltipDisabled]="!isCropYearReadOnly()"
                >
                  <button
                    [disabled]="isCropYearReadOnly()"
                    (click)="upsertManualCrop(item)"
                    mat-icon-button
                    data-test="edit-spray"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
                <div
                  [matTooltip]="
                    isCropYearReadOnly()
                      ? ('UI.CurrentYearOnlyMutationMessage' | translate)
                      : item.isParticipatingToBem
                        ? ('report.deleteCropFieldButtonDisabledTooltip' | translate)
                        : ''
                  "
                  [matTooltipDisabled]="!isCropYearReadOnly() && !item.isParticipatingToBem"
                >
                  <button
                    [disabled]="isCropYearReadOnly() || item.isParticipatingToBem"
                    (click)="deleteManualCrop(item.id!)"
                    mat-icon-button
                    data-test="delete-spray"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-details">
              <div class="detail-row">
                <span class="label">{{ 'manualCrops.province' | translate }}:</span>
                <span class="value">{{ item.province }}</span>
              </div>
              <div class="detail-row">
                <span class="label">{{ 'manualCrops.crop' | translate }}:</span>
                <span class="value">{{ item.cropName }}</span>
              </div>
              <div class="detail-row">
                <span class="label">{{ 'manualCrops.cropVariety' | translate }}:</span>
                <span class="value">{{ item.cropVarietyName }}</span>
              </div>
              <div class="detail-row">
                <span class="label">{{ 'manualCrops.areaInHectares' | translate }}:</span>
                <span class="value">{{ item.areaInHectares }}</span>
              </div>
              <div class="detail-row">
                <span class="label">{{ 'manualCrops.soilType' | translate }}:</span>
                <span class="value">{{ item.soilTypeName }}</span>
              </div>
              <div class="detail-row checkbox-row">
                <div class="checkbox-item">
                  <mat-icon>{{ item.groundwaterPreservation ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  <span>{{ 'manualCrops.groundwaterPreservation' | translate }}</span>
                </div>
                <div class="checkbox-item">
                  <mat-icon>{{ item.planetProof ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  <span>{{ 'manualCrops.planetProof' | translate }}</span>
                </div>
                <div class="checkbox-item">
                  <mat-icon>{{ item.organic ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  <span>{{ 'manualCrops.organic' | translate }}</span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    }
  </div>

  <mat-paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50]"
    [length]="(allCropFields$ | async)?.length || 0"
    (page)="page($event)"
  ></mat-paginator>
</div>
